import { useMutation, useQueryClient } from '@tanstack/react-query';

import { workspaceKeys } from '~teacher/hook/workspaces/workspaceQueryKeyFactory';

import { putWorkspaceQuizLock } from '../../../api/workspaces/lock';

export function usePutWorkspaceQuizLock() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: putWorkspaceQuizLock,
    onSuccess: (_data, { workspaceId, workspaceQuizId }) => {
      return queryClient.invalidateQueries(
        workspaceKeys.byWorkspaceQuizId({
          workspaceId,
          workspaceQuizId,
        })
      );
    },
  });
}
